import { useState } from 'react';
import { Alert, Button, Card, CardBody, Input, Label, Spinner } from 'reactstrap';
import { api } from '../../api/client.js';

const MIN_SEASON = 2025;

export function AdminSync() {
  const [season, setSeason] = useState(new Date().getFullYear());
  const [week, setWeek] = useState('');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  async function run() {
    setBusy(true);
    setError(null);
    setResult(null);

    try {
      setResult(await api.admin.sync(Number(season), week === '' ? null : Number(week)));
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ maxWidth: 640 }}>
      <h1 className="h3 mb-1">ESPN sync</h1>
      <p className="text-muted small">
        Pulls teams, schedule and scores from ESPN and re-scores any completed weeks.
        A background job already refreshes the current week automatically; use this to
        backfill a season or force an immediate refresh.
      </p>

      <Card>
        <CardBody>
          <div className="d-flex gap-3 align-items-end flex-wrap">
            <div>
              <Label for="sync-season" className="mb-1 small text-muted">Season</Label>
              <Input id="sync-season" type="number" min={MIN_SEASON} style={{ width: 120 }}
                value={season} onChange={(e) => setSeason(e.target.value)} />
            </div>
            <div>
              <Label for="sync-week" className="mb-1 small text-muted">Week (blank = all)</Label>
              <Input id="sync-week" type="number" min="1" max="22" style={{ width: 160 }}
                value={week} placeholder="All weeks" onChange={(e) => setWeek(e.target.value)} />
            </div>
            <Button color="primary" onClick={run} disabled={busy}>
              {busy ? <Spinner size="sm" /> : 'Run sync'}
            </Button>
          </div>

          {busy && (
            <p className="text-muted small mt-3 mb-0">
              Syncing a full season makes one request per week &mdash; this can take a moment.
            </p>
          )}
        </CardBody>
      </Card>

      {error && <Alert fade={false} color="danger" className="mt-3">{error}</Alert>}

      {result && (
        <Alert fade={false} color="success" className="mt-3 mb-0">
          Synced season {result.seasonYear}: {result.teamsUpserted} teams, {result.weeksUpserted} weeks,{' '}
          {result.gamesUpserted} games. {result.weeksScored} week{result.weeksScored === 1 ? '' : 's'} scored.
        </Alert>
      )}

      <p className="text-muted small mt-3">
        Seasons before {MIN_SEASON} are not supported.
      </p>
    </div>
  );
}
